import React from "react";
import { Sparkle, Instagram, Mail, Phone, MapPin, Linkedin } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#030303] border-t border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 pt-20 pb-12">
        {/* Giant logo lockup */}
        <div className="border-b border-white/10 pb-12">
          <div className="flex justify-center">
            <img
              src="/assets/nova-logo.png"
              alt="NOVA MEDIA — PR Influencers Partnerships"
              data-testid="footer-logo"
              className="w-full max-w-[240px] sm:max-w-[340px] md:max-w-[460px] lg:max-w-[560px] xl:max-w-[640px] h-auto select-none pointer-events-none"
              draggable={false}
            />
          </div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-12 gap-8 py-12">
          <div className="col-span-12 md:col-span-5">
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#7FB3D5] mb-4">
              ✦ Studio
            </p>
            <p className="font-display text-2xl md:text-3xl text-white font-light leading-snug max-w-md">
              From New York,
              <span className="italic text-[#7FB3D5]"> with intention</span>.
            </p>
            <p className="mt-4 text-sm text-white/50 max-w-md leading-relaxed">
              A boutique PR &amp; partnerships studio for ambitious founders
              ready to be heard in the rooms that matter.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-5">
              Navigate
            </p>
            <ul className="space-y-3">
              {[
                ["Services", "#services"],
                ["Process", "#process"],
                ["About", "#about"],
                ["Media Network", "#media-network"],
                ["FAQ", "#faq"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={`footer-link-${label.toLowerCase()}`}
                    className="text-sm text-white/70 hover:text-[#7FB3D5] transition-colors duration-300"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-4">
            <p className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-5">
              Reach us
            </p>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-center gap-3">
                <Phone className="w-3.5 h-3.5 text-[#7FB3D5]" strokeWidth={1.2} />
                <a href="tel:+19302055843" className="hover:text-[#7FB3D5] transition-colors">
                  +1 (930) 205-5843
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-3.5 h-3.5 text-[#7FB3D5]" strokeWidth={1.2} />
                <a href="mailto:denisse@novamediapr.com" className="hover:text-[#7FB3D5] transition-colors">
                  denisse@novamediapr.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram className="w-3.5 h-3.5 text-[#7FB3D5]" strokeWidth={1.2} />
                <a
                  href="https://instagram.com/novamediapr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#7FB3D5] transition-colors"
                >
                  @novamediapr
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Instagram className="w-3.5 h-3.5 text-[#7FB3D5]" strokeWidth={1.2} />
                <a
                  href="https://instagram.com/denissetroconisaoun"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#7FB3D5] transition-colors"
                >
                  @denissetroconisaoun
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Linkedin className="w-3.5 h-3.5 text-[#7FB3D5]" strokeWidth={1.2} />
                <a
                  href="https://www.linkedin.com/in/denissetroconisaoun"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin"
                  className="hover:text-[#7FB3D5] transition-colors"
                >
                  Denisse on LinkedIn
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-3.5 h-3.5 text-[#7FB3D5] mt-1" strokeWidth={1.2} />
                <span>26 Broadway, New York, NY 10004</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/40">
            © {new Date().getFullYear()} NOVA MEDIA. All rights reserved.
          </p>
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/40">
            novamediapr.com
          </p>
        </div>
      </div>
    </footer>
  );
}
